import axios from "axios";

let remoteStorage = {
  polling: {},
  values: {},
  server: null,
  initialized: false,
  apikey: null,
  init: function(server, apikey) {
    if (this.initialized) return;
    this.initialized = true;
    this.server = server;
    this.apikey = apikey;
  },
  refresh: function(namespace, cb) {
    if (typeof this.polling[namespace] === "undefined") {
      this.polling[namespace] = [];
      this.startPolling(this.server, namespace);
    }
    this.polling[namespace].push(cb);
  },
  callRemoteMethod: function(fn, params) {
    let p = axios.create({
      withCredentials: false,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-api-key": this.apikey
      },
      timeout: 60000
    });
    return p.post(this.server + fn, params);
  },
  get: function(namespace) {
    return this.callRemoteMethod("get", { namespace: namespace });
  },
  set: function(namespace, key, value) {
    return this.callRemoteMethod("set", {
      namespace: namespace,
      key: key,
      value: value
    });
  },
  append: function(namespace, key, value) {
    return this.callRemoteMethod("append", {
      namespace: namespace,
      key: key,
      value: value
    });
  },
  insert: function(namespace, key, value) {
    return this.callRemoteMethod("insert", {
      namespace: namespace,
      key: key,
      value: value
    });
  },
  pop: function(namespace, key) {
    return this.callRemoteMethod("pop", { namespace: namespace, key: key });
  },
  popLeft: function(namespace, key) {
    return this.callRemoteMethod("popLeft", { namespace: namespace, key: key });
  },
  increment: function(namespace, key) {
    return this.callRemoteMethod("increment", {
      namespace: namespace,
      key: key
    });
  },
  decrement: function(namespace, key) {
    return this.callRemoteMethod("decrement", {
      namespace: namespace,
      key: key
    });
  },
  startPolling: function(server, namespace) {
    this.getChanges(server, namespace, "");
  },
  getChanges: function(server, namespace, hash) {
    let self = this;
    let p = axios.create({
      withCredentials: false,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-api-key": this.apikey
      },
      timeout: 30000
    });
    p.get(self.server + "getChanges?namespace=" + namespace + "&hash=" + hash)
      .then(response => {
        if (self.polling[namespace]) {
          self.polling[namespace].forEach(cb => {
            cb(response.data.data);
          });
        }
        setTimeout(function() {
          self.getChanges(self.server, namespace, response.data.hash);
        }, 1000);
      })
      .catch(() => {
        setTimeout(function() {
          self.getChanges(self.server, namespace, hash);
        }, 5000);
      });
  }
};

export default remoteStorage;
